import func from "@uikit/func";
import { useEffect, useRef, useState } from "react";
import { ChatBloc } from "./ChatBloc";

export const useChatV3 = (props: { bloc: ChatBloc }) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [regenerateLoading, setRegenerateLoading] = useState(false);
  const [submitValue, setSubmitValue] = useState("");

  const chatBoxListRef = useRef<null | HTMLDivElement>(null);

  const moveListScrollBarToBottom = () => {
    if (chatBoxListRef.current) {
      if (chatBoxListRef.current.scrollHeight <= chatBoxListRef.current.clientHeight) return;
      chatBoxListRef.current.scrollTo({
        top: chatBoxListRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const clickRegenerateBtn = async () => {
    //   if (submitLoading || regenerateLoading) return;
    //   const filterChatList = chatList.filter((x, idx) => !(x.type === "assistant" && idx === chatList.length - 1));
    //   setRegenerateLoading(true);
    //   await postStreamingApi(filterChatList);
    //   setRegenerateLoading(false);
    // };
  };

  const onPressEnter = async () => {
    if (func.isEmpty(submitValue)) {
      func.customMsg({
        content: "Message cannot be empty",
        type: "warning",
      });
      return;
    }
    if (submitLoading || regenerateLoading) return;

    setSubmitValue("");

    setSubmitLoading(true);
    await props.bloc.getNewChatInfoByAPI(submitValue);
    setSubmitLoading(false);
  };

  useEffect(() => {
    if (props.bloc.state.message.value.length) {
      moveListScrollBarToBottom();
    }
  }, [props.bloc.state.message.value]);

  return {
    submitValue,
    setSubmitValue,
    submitLoading,
    regenerateLoading,
    onPressEnter,
    chatBoxListRef,
    clickRegenerateBtn,
  };
};
